module.exports = __webpack_public_path__ + "static/img/star.19c3d63d.svg";